export default __webpack_public_path__ + "static/media/img13.cb806fbc.jpg";